<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="color"
      fill-rule="nonzero"
      d="M.656 21c-.131 0-.262 0-.394-.131-.13-.132-.262-.395-.262-.526V.624C0 .362.131.23.263.1c.13-.132.393-.132.656 0l19.687 9.859c.263.131.394.394.394.526 0 .131-.131.525-.394.525L.92 20.87c-.132 0-.132.131-.263.131z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 21,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>
